<!-- Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied. -->
<template>
  <div class="dc--faq">
    <h2 class="display-3 pt-4 pb-2">Frequently Asked Questions</h2>
    <v-text-field
      label = "Search"
      single-line
      clearable
      prepend-icon = "filter_list"
      solo
      v-model = "search"
      ref = "search"
      class = "my-2"
    />
    <v-fade-transition>
      <v-card
        class="mb-3"
        color = "warning"
        v-if="total_qs === 0">
        <v-card-text>
          <h3>No Results Found</h3>
          <v-btn
            color = "secondary"
            @click = "resetSearch">
            Reset Search
          </v-btn>
        </v-card-text>
      </v-card>
    </v-fade-transition>
    <v-card class="mb-3">
      <v-card-text>
        <v-layout
          row
          wrap>
          <v-flex xs12><h3 class="headline">Jump To:</h3></v-flex>
          <v-flex
            md4
            v-for = "(section, i) in shown_qs"
            :key = "'header' + i">
            <a :href = "'#section' + i">
              <strong>{{ section.section }}</strong>
            </a>
            ({{ section.qs.length }})
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card
      class="mb-3"
      v-for = "(section, i) in shown_qs"
      :key = "i">
      <v-card-text>
        <h3 class="headline">
          {{ section.section }}
          <a :name = "'section' + i"/>
        </h3>
        <div v-if = "!section.qs.length">
          <v-card>
            <v-card-text>
              <h3>No Matching Questions</h3>
            </v-card-text>
          </v-card>
        </div>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for = "(faq, j) in section.qs"
            :key = "j">
            <div
              slot="header"
              class = "pr-5 subheading">
              {{ faq.q }}
            </div>
            <v-divider/>
            <v-card color="secodary">
              <v-card-text
                color="secodary"
                class="body-1">
                {{ faq.a }}
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import * as VGrid from 'vuetify/es5/components/VGrid'
import * as VCard from 'vuetify/es5/components/VCard'
import * as VExpansionPanel from 'vuetify/es5/components/VExpansionPanel'
import VBtn from 'vuetify/es5/components/VBtn'
import VDivider from 'vuetify/es5/components/VDivider'
import VTextField from 'vuetify/es5/components/VTextField'
import { VFadeTransition } from 'vuetify/es5/components/transitions'
import faqs from '@/docs/help/faq.js'

export default {
  data: () => ({
    search: '',
  }),
  computed: {
    shown_qs () {
      return faqs.map(i => {
        return {
          section: i.section,
          qs:      i.qs.filter(q => {
            const answer = q.a.toLowerCase()
            const question = q.q.toLowerCase()
            const search = (this.search || '').toLowerCase()
            return answer.indexOf(search) > -1 ||
                   question.indexOf(search) > -1
          }),
        }
      })
    },
    total_qs () {
      return this.shown_qs.reduce((t, s) => {
        return t + s.qs.length
      }, 0)
    },
  },
  methods: {
    resetSearch () {
      this.search = ''
      this.$refs.search.focus()
    },
  },
  components: {
    ...VCard,
    ...VGrid,
    ...VExpansionPanel,
    VBtn,
    VDivider,
    VTextField,
    VFadeTransition,
  },
}
</script>
<style scoped>
.dc--faq {
  max-width: 800px;
}
</style>
